import React, { useContext, useState, useEffect } from "react";
import { Bar, Line } from "react-chartjs-2";
import {
  GraficoPocoStyled,
  CalendarioBombaStyled,
} from "../../Styles/GraficoPoco";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { CiCalendar } from "react-icons/ci";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ElevatoriaContext } from "../../Context/contextElevatoria";
import {
  ModalCalenderBomba,
  ModalCalenderPoco,
} from "../../Styles/GraficoPoco";
import { apiSae } from "../../services/api";
import { formatInTimeZone } from "date-fns-tz";
import { HomeContext } from "../../Context/ContextHome";
import { format } from "date-fns";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { GradeContext } from "../../Context/ContextGrade";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const GraficoPocograde = (pros) => {
  const { idPoco, altura } = pros;

  const {
    modalGraficoOpen,
    setModalGraficoOpen,
    selectedDate,
    setIdDataGrade,
    dataGrade,
  } = useContext(GradeContext);

  const { socket } = useContext(HomeContext);

  const [listGrafico, setListGrafico] = useState([]);
  const [numeroCalendario, setNumeroCalendario] = useState("");
  const [pocoCalender, setPocoCalender] = useState("");

  const ListarData = (data) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const response = data.toLocaleDateString("pt-BR", options);
    setNumeroCalendario(response);
  };

  const formatTime = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "HH:mm:ss");
  };

  const renderData = async (data) => {
    const year = data.getFullYear();
    const month = String(data.getMonth() + 1).padStart(2, "0");
    const day = String(data.getDate()).padStart(2, "0");

    const token = localStorage.getItem("tokenBrk");

    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      ListarData(data);
      setPocoCalender(data);
      const response = await apiSae.get(
        `historico/grade/data/${idPoco}/${day}-${month}-${year}`,
        headerApi
      );
      setListGrafico(response.data);
    } catch (error) {
      setListGrafico([]);
    }
  };

  useEffect(() => {
    renderData(selectedDate);
  }, [idPoco]);

  const Dados = {
    labels: listGrafico.map((label) => formatTime(label.timestamp)),
    datasets: [
      {
        label: `Nível do Poço`,
        data: listGrafico.map((data) => data.nivel_atual),
        backgroundColor: "#60ABFF",
      },
    ],
  };

  useEffect(() => {
    if (modalGraficoOpen) {
      document.body.classList.add("modal-open"); // Adiciona a classe overflow-hidden ao body quando o modal é aberto
    } else {
      document.body.classList.remove("modal-open"); // Remove a classe overflow-hidden do body quando o modal é fechado
    }

    // Limpa a classe quando o componente é desmontado para evitar vazamentos de memória
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modalGraficoOpen]);

  const Opcoes = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          boxWidth: 15,
        },
        margin: {
          top: 5,
        },
      },
      title: {
        display: true,
        text: `${numeroCalendario}`,
        font: {
          size: 14,
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: true,
          maxTicksLimit: 24,
        },
      },
      y: {
        min: 0,
        max: altura,
      },
    },
  };

  useEffect(() => {
    const novaDataCalendario = dataGrade.filter((id) => id.id_poco === idPoco);
    if (novaDataCalendario.length >= 1) {
      renderData(novaDataCalendario[0].data);
    }
  }, [dataGrade, selectedDate]);

  useEffect(() => {
    if (socket) {
      if (pocoCalender !== "") {
        socket.on("creat_newHistorico", () => {
          renderData(pocoCalender);
        });
      } else {
        socket.on("creat_newHistorico", () => {
          renderData(selectedDate);
        });
      }
    }
  }, [socket]);

  return (
    <GraficoPocoStyled>
      <div className="TitleContainer">
        <CiCalendar
          className="CiCalendar"
          onClick={() => {
            setModalGraficoOpen(!modalGraficoOpen);
            setIdDataGrade(idPoco);
          }}
        />
        <span className="DateText">{numeroCalendario.split(" ")[0]}</span>
      </div>
      <Bar data={Dados} options={Opcoes} />
    </GraficoPocoStyled>
  );
};

export const ModalCalendarioGrafico = () => {
  const {
    setModalGraficoOpen,
    setDataGrade,
    idDataGrade,
    setSelectedDate,
    selectedDate,
  } = useContext(GradeContext);

  const closeModal = () => setModalGraficoOpen(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);

    setDataGrade((prevDataPoco) => {
      const index = prevDataPoco.findIndex(
        (item) => item.id_poco === idDataGrade
      );

      if (index !== -1) {
        const updatedDataPoco = [...prevDataPoco];
        updatedDataPoco[index] = { ...updatedDataPoco[index], data: date };
        return updatedDataPoco;
      } else {
        return [...prevDataPoco, { id_poco: idDataGrade, data: date }];
      }
    });

    closeModal();
  };

  return (
    <ModalCalenderPoco>
      <div className="conteiner">
        <h2>Selecionar Data</h2>
        <DatePicker
          className="agenda"
          selected={selectedDate}
          onChange={handleDateChange}
          inline
        />
        <button className="botaoFechaAgenda" onClick={closeModal}>
          x
        </button>
      </div>
    </ModalCalenderPoco>
  );
};
